import './Style.scss';
import { getLocalization } from 'global/global';
import * as React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Papa from 'papaparse';

interface Props {
  setImportParams: (fileRow: string[], tempData: string[][], file: File, delimeter: string) => void;
}

export default function ImportFileSelector(props: Props) {

  const fileInput = React.useRef<HTMLInputElement | null>(null);
  const [fileTypeError, setFileTypeError] = React.useState(false);
  const [file, setFile] = React.useState<File | null>(null);
  const [fileData, setFileData] = React.useState('');
  const [separator, setSeparator] = React.useState('');
  const [customSeparator, setCustomSeparator] = React.useState('');

  const onFileSelectClick = () => {
    if (fileInput.current) {
      fileInput.current.click();
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      const files: FileList = e.target.files;
      let i = 0;
      let f: File;
      let ftError = false;
      while (i < files.length) {
        f = files[i];
        if (!(f.type.match('text/csv') || f.type.match('text/plain') ||
        (f.type.match('application/vnd.ms-excel') && f.name.endsWith('.csv')))) {
          ftError = true;
          setFileTypeError(ftError);
          return;
        }
        if (f) {
          const reader = new FileReader();
          reader.onload = (() => {
            return (e) => {
              setFile(f);
              setFileTypeError(ftError);
              if (e.target && typeof e.target.result === 'string') {
                setFileData(e.target.result);
              }
              /* const data = Papa.parse(e.target.result);
              if (data.data.length > 0) {
                this.fileRow = data.data[0];
                this.tempData = data.data.slice(1, 5);
              }
              if (this.state.form !== '') {
                this.loadQuestions();
              }*/
            };
          })(f);
          reader.readAsText(f);
        }
        i++;
      }
    }
  };

  const processFile = () => {
    const sep = separator === 'custom' ? customSeparator : separator === 'detect' ? undefined : separator;
    const data = Papa.parse(fileData, {
      delimiter: sep
    });
    if (data.data.length > 0 && file) {
      const fileRow = data.data[0];
      const tempData = data.data.slice(1, 5);
      props.setImportParams(fileRow, tempData, file, data.meta.delimiter);
    }
  };

  return (
    <>
      <div className="form-group mb-3">
        {fileTypeError && (<p className="bg-danger error-alert">{getLocalization('onlyCsv')}</p>)}
        <button className="btn btn-sm btn-primary" onClick={onFileSelectClick}>
          {getLocalization('selectImportFile')}
        </button>
        <input
          ref={fileInput}
          type="file"
          name="importFileSelect"
          accept=".csv, .tsv, .txt, plain/text"
          className="d-none"
          onChange={handleFileChange}
        />
        <span id="import-file-name">
          {file && file.name}
        </span>
      </div>
      {fileData && (
        <Row>
          <Form.Group as={Col}>
            <Form.Label>{getLocalization('separatorType')}</Form.Label>
            <Form.Select
              size="sm"
              value={separator}
              onChange={(e) => setSeparator(e.target.value)}
            >
              <option value="detect">{getLocalization('detectAutomatically')}</option>
              <option value="	">{getLocalization('tab')}</option>
              <option value=",">{getLocalization('comma')}</option>
              <option value="custom">{getLocalization('custom')}</option>
            </Form.Select>
          </Form.Group>
          {separator === 'custom' && (
            <Form.Group as={Col}>
              <Form.Label>{getLocalization('customSeparator')}</Form.Label>
              <Form.Control
                type="text"
                value={customSeparator}
                size="sm"
                onChange={(e) => setCustomSeparator(e.target.value)}
              />
            </Form.Group>
          )}
          <Form.Group as={Col} className="align-btn-end">
            <Button
              size="sm"
              disabled={separator === 'custom' && customSeparator === ''}
              onClick={processFile}
            >
              {getLocalization('processFile')}
            </Button>
          </Form.Group>
        </Row>
      )}
      <hr />
    </>
  );
}
